/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetCompositionsDetailEditsQueryResponse, WebAppGetCompositionsDetailEditsPathParams, WebAppGetCompositionsDetailEdits401, WebAppGetCompositionsDetailEdits403 } from "../models/WebAppGetCompositionsDetailEdits";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetCompositionsDetailEdits } from "../axios/webAppGetCompositionsDetailEdits";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetCompositionsDetailEditsQueryKey = (id: WebAppGetCompositionsDetailEditsPathParams["id"]) => ["api-v2", { url: '/web-app/v1/compositions/:id/edits', params: {id:id} }] as const

export type WebAppGetCompositionsDetailEditsQueryKey = ReturnType<typeof webAppGetCompositionsDetailEditsQueryKey>

export function webAppGetCompositionsDetailEditsQueryOptions(id: WebAppGetCompositionsDetailEditsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetCompositionsDetailEditsQueryKey(id)
        return queryOptions<WebAppGetCompositionsDetailEditsQueryResponse, ResponseErrorConfig<WebAppGetCompositionsDetailEdits401 | WebAppGetCompositionsDetailEdits403>, WebAppGetCompositionsDetailEditsQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetCompositionsDetailEdits(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List video-editor edits for a composition
 * {@link /web-app/v1/compositions/:id/edits}
 */
export function useWebAppGetCompositionsDetailEdits<TData = WebAppGetCompositionsDetailEditsQueryResponse, TQueryData = WebAppGetCompositionsDetailEditsQueryResponse, TQueryKey extends QueryKey = WebAppGetCompositionsDetailEditsQueryKey>(id: WebAppGetCompositionsDetailEditsPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetCompositionsDetailEditsQueryResponse, ResponseErrorConfig<WebAppGetCompositionsDetailEdits401 | WebAppGetCompositionsDetailEdits403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetCompositionsDetailEditsQueryKey(id)
         

         const query = useQuery({
          ...webAppGetCompositionsDetailEditsQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WebAppGetCompositionsDetailEdits401 | WebAppGetCompositionsDetailEdits403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}